export function isWhitelabel(host: string): boolean {
  return host.includes('iframe.')
}